#dotboxGrid {
  margin-top: 1em;
  grid-row: 2/4;
  width: 25em;
  height: 25em;
  display: grid;
  grid-template: auto 1fr auto 1fr auto 1fr auto/ auto 1fr auto 1fr auto 1fr auto;
}

@media screen and (min-width: 700px) {
  #dotboxGrid {
    width: 35em;
    height: 35em;
  }
}

@media screen and (min-width: 1800px) {
  #dotboxGrid {
    width: 45em;
    height: 45em;
  }
}

.dot {
  z-index: 1;
  height: 1.5em;
  width: 1.5em;
  background-color: var(--accent-color);
  border-radius: 50%;
  display: inline-block;
}

.sideBtn {
  background-color: var(--box-side-color);
  border: none;
}

.selectable:hover {
  cursor: pointer;
  box-shadow: 0 0.5em 3em var(--accent-color);
}

.horizonBtn {
  height: 1em;
  align-self: center;
  margin: 0 -0.5em;
}

.verticaBtn {
  width: 1em;
  justify-self: center;
  margin: -0.5em 0;
}

.player1Color {
  background-color: var(--accent-color);
}
.player2Color {
  background-color: var(--secondary-color);
}
